<p>calenderview works!</p>
<full-calendar [options]="calendarOptions"></full-calendar>
